angular.module('v3sWbtPlayerApp').directive('v3sPopupTooltip', [function () {
    return {
        restrict: "E",
        scope: {
            v3sPopup: "=",
            v3sClose : "&"
        },
        templateUrl: "app/js/page/popup/v3sPopupTooltip.tpl.html",
        link: function (scope, el, attrs) {
            scope.hidePopup = function (evt) {
                evt.stopPropagation();
                evt.preventDefault();
                scope.v3sClose();
            }
        }
    }

}]);